import { render } from "./AppFooter.vue?vue&type=template&id=4efda582"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import "./AppFooter.vue?vue&type=style&index=0&id=4efda582&lang=scss"

import exportComponent from "C:\\git\\Source\\Repos\\LDI.ApplicationSupport.ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__